module.exports = __webpack_public_path__ + "static/media/205_SHOT_111.707d48e1.webp";